{
  "cc": "Käesolev sisu on litsentsitud Creative Commons Autorile viitamine-Mitteäriline eesmärk 4.0 Rahvusvaheline alusel (CC BY-NC).",
  "language": "Keele valik",
  "unexpected_error": "Ootamatu tõrge! Palun salvestage vastused kohalikule kettale ning proovige mõne aja pärast uuesti!",
  "conformation_internet": "Rakendus edastab päringu läbi Interneti, et alla laadida uusim küsimustik.",
  "invalid_file": "Üleslaaditud fail on vigane. Palun proovige uuesti.",
  "conformation_benchmark": "Rakendus edastab päringu läbi Interneti, et alla laadida uusim mõõtlusalus.",
  "conformation_internet2": "Andmed edastatakse andmebaasi. Rakendus edastab päringu läbi Interneti.",
  "back": "Eelmine",
  "download": "Laadi kohalikule kettale fail ",
  "back_2": "Katkesta",
  "back_answering": "Tagasi vastama",
  "conformation_incomplete_q": "Käesolev seis kustutatakse. Hiljem jätkamiseks salvesta detailsed vastused kohalikule kettale.",
  "continue": "Jätka",
  "end": "Lõpeta",
  "green": "Väide vastab sinu organisatsiooni kontekstis täielikult tõele",
  "to_start": "Avalehele",
  "incomplete": "Mõningad küsimused on jäänud vastamata!",
  "version" : "Küsimustiku versioon",
  "introduction": {
    "header": "Organisatsiooni infoturbe küpsustaseme hindamine",
    "time_estimate": "Täname, et olete otsustanud oma organisatsiooni infoturbe halduse küpsust hinnata meie töövahendiga. Töövoo läbimiseks kulub eelduslikult 30-75min.",
    "evaluation": "Hindamine baseerub Eesti Infoturbestandardi (E-ITS https://eits.ria.ee) meetmetel, ENISA 2022 Threat Landscape Report (DOI: 10.2824/764318) soovitustel ja hõlmab ISO27002:2022 juhtimiseesmärke.",
    "apply": "Kõigi väidete hindamise järel saab vastaja koheselt ülevaate oma organisatsiooni infoturbehalduse olukorrast allalaetava failina ja visuaalse graafikuna kümnes infoturbe halduse moodulrühmas (dimensioonis), mida on võimalik kasutada oma infoturbe halduse edasisel plaanimisel.",
    "principles": "Põhimõtted:",
    "principle_1": "* Detailseid vastused eksisteerivad ainult vastaja, st Teie arvutis.",
    "principle_2": "* Kui nõustute edastama serverisse oma organisatsiooni küpsusastmete kaupa agregeeritud arvväärtused, saame teie organisatsiooni tulemuste kõrvale lisaks pakkuda võrdlusandmeid teiste organisatsioonide keskmistatud tulemusena (kui need on serveris selleks hetkeks olemas).",
    "principle_3": "* Vastamise katkestamisel ja hiljem jätkamiseks või ülevaatamiseks on võimalik vastused salvestada enda  arvutisse (vt \"kodu\" nupp).",
    "principle_4": "* Teie nõusolekul edastatakse serverisse ainult vastuste keskmistatud arvväärtused ning Teie poolt sisestatud informatsioon organisatsiooni kohta. Enne serverisse edastamist on Teil võimalik edastatavate andmetega tutvuda ja enda jaoks salvestada.",
    "data_processing": "Andmetöötluse põhimõtted:",
    "data_processing_1": "* E-posti aadressi kasutatakse ainult teavitamaks, kui on avaldatud uus küsimustiku versioon või uued võrdlusandmed (ainult CHESS projekti ajal).",
    "data_processing_2": "* Organisastiooni nimi on vajalik domeeni täpsustamiseks, dubleerivate tulemuste tuvastamiseks ning kordusmõõtmistel tulemuste dünaamika jälgimiseks.",
    "data_processing_3": "* Küpsusastmete kaupa keskmistatud tulemusi analüüsitakse ja presenteeritakse ilma organisatsioonide nimedeta.",
    "data_processing_4": "* Mõõtmistulemusi üksiku asutuse kontektis kasutatakse ainult anonümiseeritult. Domeeni ehk tegevusvaldkonna ja asutuse suuruse vms põhiseid üldistatud tulemusi avaldatakse vaid juhul, kui mõõtmistulemusi on vähemalt viielt vastavasse gruppi kuuluvalt asutuselt.",
    "data_processing_5": "* Andmeid kasutatakse teadustööks ja domeenipõhiste ning üldise võrdlusaluse väljatöötamiseks riiklikul tasandil koostöös Eesti Riigi Infosüsteemi Ametiga (RIA).",
    "processor": "Vastutav andmetöötleja:",
    "ut": " Tartu Ülikool.",
    "developers": "Küpsusmõõdiku (F4SLE) põhimõtted on väljatöötanud Mari Seeba (TÜ, RIA). Mõõtmise tööriista (MASS) on arendanud Maria Pibilota Murumaa (TÜ, Cybernetica AS). Ekspertidena on kaasatud Tarmo Oja (TÜ, Cybernetica AS), Vaclav Matyas (MUNI) ja Vaclav Stupka (MUNI). Mõõtmise projekt on Eesti ja Tšehhi Vabariigi Lõuna-Moravia piirkonna vahelise teaduskoostöö projekti CHESS alamprojekt.",
    "contact": "Küsimuste korral pöörduge",
    "disclaimer": "Kaasrahastanud Euroopa Liit Grandi leping number 101087529. Siin väljendatud seisukohad ja arvamused kuuluvad ainult nende autori(te)le ega kajasta tingimata Euroopa Komisjoni seisukohta. Euroopa Liit ega toetuse andja nende eest ei vastuta."
  },
  "more_info": "Lisainfo",
  "new_questionnaire": "Alusta uue küsimustiku täitmist",
  "next": "Järgmine",
  "no_answer": "Jätan vastamata",
  "not_applicable": "Ei kehti",
  "orange": "Väide on osaliselt vastav olukorra kirjeldusele, kuid siiski oluliste puudustega",
  "red": "Väites kirjeldatud olukorra jaoks ei ole veel midagi olulist tehtud",
  "results": {
    "maturity_levels": "Küpsustasemed",
    "more": "Vastuste keskmistatud arvväärtuste edastamisel andmebaasi, kuvatakse Teie organisatsiooni tulemuste kõrvale lisaks teiste organisatsioonide keskmistatud tulemused. Selleks vajutage järgnevat nuppu:",
    "save_local": "Salvesta detailsed vastused kohalikule kettale",
    "save_summary_local": "Salvesta tulemuste metaandmed kohalikule kettale",
    "goal": "Eesmärk",
    "results": "Tulemused",
    "initial": "Alustatud",
    "defined": "Defineeritud",
    "basic": "Põhiturve",
    "standard": "Standardturve",
    "benchmark_results": "Tulemused võrreldes mõõtlusalusega",
    "initiated_description": " Head praktikaid pole rakendatud, riske pole teadvustatud, juhtkond pole initsiatiivi võtnud. Turvetegevused on juhuslikud ja pigem algatatud rohujuure tasandil.",
    "defined_description": "Protsessid ja tegevused on alustatud, kui toimuvad ad hoc. Dokumendid on koostatud, kuid osaliselt vananenud või ei vasta tegelikkusele. ",
    "basic_description": "Praktikad toimivad, on dokumenteeritud, ressursid plaanitud, rollid ja kohustused jaotatud. Tegevuste regulaarsus pole veel saavutatud.",
    "standard_description": " On selged üle organisatsioonilised poliitikad ja printsiibid. Tegevusi seiratakse ja need on jälgitavad, tegevused on standardiseeritud ja dokumenteeritud. Toimub pidev parendamine. Erandeid seiratakse.",
    "initial_range": "<0.75 ALUSTATUD",
    "defined_range": ">=0.75 ja <1.5 DEFINEERITUD",
    "basic_range": ">=1.5 ja <2.25 PÕHITURVE",
    "standard_range": ">2.25 STANDARDTURVE",
    "initiated_description2": "Infoturbega tegelemise vajadus on teadvustatud ja sellega tegeletakse.",
    "defined_description2": "Kokku on lepitud formaalsed protsessid ja koostatud vajalikud infoturvet toetavad dokumendid.",
    "basic_description2": "Rakendatud on praktilised tegevused infoturbe haldamiseks.",
    "standard_description2": "On selged üle organisatsioonilised poliitikad ja printsiibid. Tegevused on standardiseeritud, dokumenteeritud, regulaarsed ja  jälgitavad. Toimub pidev seire ja parendamine.",
    "initiated": "ALUSTATUD",
    "process_dim": "Protsessi dimensioonid",
    "system_dim": "Süsteemi dimensioonid",
    "PDF": "Genereeri PDF",
    "send_data": "Saada andmed serverisse ja lae võrdlusandmed"
  },
  "send_results": {
    "more_info":"Andmetöötluse põhimõtetega saab tutvuda siin",
    "validation": "Puudulik või vale sisend väärtustel:",
    "description": "Tagasiside ning andmete kogumine",
    "token": "Tooken",
    "feedback": "Tagasiside",
    "db_address": "Andmebaasi aadress",
    "send": "Saada tulemused",
    "back": "Tagasi",
    "info_sent": "Serverisse edastatavate andmete eelvaade",
    "loading": "Laadimine",
    "time_estimate": "Küsimustikule vastamiseks kulunud aeg *",
    "send_database": "Andmebaasi edastatav info",
    "time": "Kulunud aeg",
    "thank_you": "Aitäh osalemast!",
    "success": "Andmed on edastatud andmebaasi!",
    "home": "Avalehele",
    "email": "Meili aadress (teavituste saamiseks nt. võrdlusandmed, küsimustik)",
    "role": "Amet  *",
    "other_role": "Sisestage amet *",
    "other_domain": "Sisestage domeen *",
    "it_dep":"Organisatsiooni sisese infoturvalisuse või IT-haldusega tegelevate inimeste arv *",
    "it_dep_explanation": "Arvestage kõiki inimesi, kes tööajast tegelevad 50% või rohkem IT-halduse või infoturvalisusega.",
    "role_list": {
      "management": "Juht",
      "auditor": "Audiitor",
      "info_manager": "Infoturbejuht /-spetsialist",
      "IT_manager": "IT juht",
      "network": "Võrgu/süsteemi administraator",
      "admin": "Haldusassistent/advokaat/DPO",
      "other": "Muu"
    },
    "org_name": "Organisatsiooni nimi  *",
    "domain": "Organisatsiooni domeen  *",
    "other_country_2": "Sisestage riik *",
    "domain_list": {
      "healthcare": "Tervishoid",
      "education": "Haridus ja teadus",
      "municipality": "KOV",
      "ICT": "IKT",
      "non-profit": "Mittetulundusühing",
      "finance": "Finants",
      "digital_service": "Digitaristu",
      "energy": "Energeetika",
      "water_heating": "Vesi ja kaugküte",
      "transport": "Transport",
      "other": "Muu",
      "public_admin": "Avaliku halduse üksused",
      "space": "Kosmos",
      "postal": "Posti- ja kullerteenused",
      "waste": "Jäätmekäitlus",
      "chemicals": "Kemikaalide valmistamine, tootmine ja levitamine",
      "food": "Toiduainete tootmine, töötlemine ja turustamine",
      "manufactoring": "Töötlev tööstus",
      "digi": "Digiteenuse osutaja"
    },
    "workplaces": "Töötajate arv  *",
    "time_list": {
      "30_minutes": "Ligi 30 minutit",
      "1_hour": "Ligi 1 tund",
      "2_hours": "2 tundi",
      "4_hours": "2-4 tundi",
      "8_hours": "4-8 tundi",
      "workday": "Rohkem kui 1 tööpäev"
    },
    "standard": "Rakendatud standardid",
    "country": "Riik *",
    "estonia": "Eesti",
    "czech": "Tšehhi",
    "other_country": "Muu",
    "standard_list": {
      "ISO": "ISO/IEC 27001",
      "NIST": "NIST CSF",
      "CIS": "CIS Controls",
      "ISKE": "ISKE (Eesti)",
      "KYTS": "KüTS (Eesti)",
      "BSI": "BSI IT Grundshutz (Saksa)",
      "EITS": "E-ITS (Eesti)",
      "CzechAct": "Act on cyber security, nr. 181/2014 Coll. (Tšehhi)"
    },
    "refuse": "Ei soovi andmekorjes osaleda"
  },
  "unfinished_questionnaire": "Ava eelnevalt salvestatud poolik vastuste fail kohalikult kettalt",
  "upload_file_text": "Palun valige .txt fail:",
  "yellow": "Väide on kooskõlas sinu organisastiooniga, kuid mõningate puudustega",
  "result_upload": "Ava eelnevalt salvestatud tulemuste fail kohalikult kettalt"
}